export function GeneralError() {
  return (
    <>
      <h1 class="text-red-400 font-semibold text-6xl">
        Oops! We can’t come back...{" "}
      </h1>
      <div class="text-3xl pt-8">
        <p>Something terrible happened.</p>
        <p>The log is on the way and we'll work on it!</p>
      </div>
    </>
  );
}
